import { Grid, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { IPost } from '_interfaces/post.interface';
import DeleteIcon from 'assets/icons/buttons/delete.svg';
import EditIcon from 'assets/icons/buttons/edit.svg';
import { postCommentsAtom, selectedProjectAtom } from 'atoms';
import { ICustomMentionData } from 'components/inputs/draft-js-input';
import useToast from 'hooks/useToast';
import { useAtomValue } from 'jotai';
import { FC, useCallback } from 'react';
import { useGetMeQuery } from 'redux-store/api/auth';
import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';
import CommentItem from './components/comment-item';
import CommentLikersListModal from './components/comment-likers';
import { commentsStyles } from './styles/styles';
import { IPostComment } from '_interfaces/postComment.interface';

interface ICommentsProps {
  placeOfUse: 'activity_feed' | 'post_modal';
  comments: IPostComment[];
  searchQuery: string;
  styleOverrides?: {
    container?: SystemStyleObject<Theme>;
    content?: SystemStyleObject<Theme>;
  };
  circularProgress?: boolean;
  mentionOptions: ICustomMentionData[];
}

const Comments: FC<ICommentsProps> = ({
  placeOfUse,
  comments,
  searchQuery,
  styleOverrides = {
    container: null,
    content: null,
  },
  mentionOptions,
}) => {
  const showToast = useToast();
  const selectedProject = useAtomValue(selectedProjectAtom);

  const { data: userMe } = useGetMeQuery();
  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery();

  const createCommentActionsMenuItems = useCallback(
    (onEdit: () => void, onDelete: () => void, commentUserId: number) => {
      const commentActionsMenu = [];

      if (userMe?.id === commentUserId) {
        commentActionsMenu.push({
          label: 'Edit',
          Icon: EditIcon,
          onClick: onEdit,
        });
      }
      if (
        (userPermissions?.ACTIVITY_FEED_ALL_POSTS?.canDelete &&
          userPermissions?.ENABLE_ACTIVITY_FEED?.canDelete) ||
        userMe?.userId === commentUserId
      ) {
        commentActionsMenu.push({
          label: 'Delete',
          Icon: DeleteIcon,
          onClick: onDelete,
        });
      }

      return commentActionsMenu;
    },
    [userPermissions, userMe]
  );

  const { container, content } = styleOverrides;

  return (
    <Grid sx={[{ width: '100%', display: 'flex' }, container]}>
      <Grid sx={[commentsStyles.container, content]}>
        {comments.length
          ? comments.map((comment) => (
              <CommentItem
                key={`${placeOfUse}${comment?.id}`}
                parentPath={comment.parentPath}
                comment={comment}
                searchQuery={searchQuery}
                project={selectedProject}
                createCommentActionsMenuItems={createCommentActionsMenuItems}
                mentionOptions={mentionOptions}
              />
            ))
          : null}
      </Grid>
      <CommentLikersListModal />
    </Grid>
  );
};

export default Comments;
